import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { BusinessInfoState } from 'typings/reduxStore'

export const initState: BusinessInfoState = {
  isLoading: true,
  contactInfo: [],
  isResponseFailure: false,
  errorMessage: '',
  isUpdated: false
}

const businessInfoSlice = createSlice({
  name: 'businessInfoSlice',
  initialState: initState,
  reducers: {
    updateBusinessInfoState: (
      state: BusinessInfoState,
      action: PayloadAction<BusinessInfoState>
    ) => {
      return {
        ...state,
        ...action.payload
      }
    }
  }
})

export const { updateBusinessInfoState } = businessInfoSlice.actions

export default businessInfoSlice.reducer
